import { memo } from 'react';

import { useTableContext } from '../../context.tsx';
import { TableCellContentType } from '../../types.ts';
import { SubRowContent, SubRowPlaceholder, SubRowWrapper } from './styled.ts';
import type { SubRowProps } from './types.ts';

export { SubRowsContainer } from './styled.ts';

export const SubRow = memo(function SubRow({ children, className }: SubRowProps) {
  const { compact, hasDnd, hasCheckbox, hasAction, columnCount } = useTableContext();

  // Guard against `grid-column: span 0` (collapses the cell) when a table has only special columns.
  const contentSpan = Math.max(1, columnCount - (hasDnd ? 1 : 0) - (hasCheckbox ? 1 : 0) - (hasAction ? 1 : 0));

  return (
    <SubRowWrapper className={className} $compact={compact}>
      {hasDnd && <SubRowPlaceholder $contentType={TableCellContentType.DND} $compact={compact} />}
      {hasCheckbox && <SubRowPlaceholder $contentType={TableCellContentType.CHECKBOX} $compact={compact} />}
      <SubRowContent $compact={compact} $colSpan={contentSpan}>
        {children}
      </SubRowContent>
      {hasAction && <SubRowPlaceholder $contentType={TableCellContentType.ACTION} $compact={compact} />}
    </SubRowWrapper>
  );
});
